export default __webpack_public_path__ + "static/media/home_product_customer.ba1c2502.png";